import { Component } from 'react'
import type { ReactNode, ErrorInfo } from 'react'
import { Button, Alert } from './ui'

type Props = { children: ReactNode }
type State = { error: Error | null }

/**
 * กันหน้าจอขาวทั้งแอปเมื่อมี component พัง
 * พนักงานภาคสนามต้องเห็นข้อความที่ทำอะไรต่อได้ ไม่ใช่หน้าว่างเปล่า
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('UI พัง', error, info.componentStack)
  }

  override render(): ReactNode {
    const { error } = this.state
    if (!error) return this.props.children

    return (
      <div className="mx-auto max-w-lg space-y-4 p-6">
        <Alert variant="error">
          <p className="font-medium">เกิดข้อผิดพลาดในการแสดงผล</p>
          <p className="mt-1 text-xs opacity-80">{error.message}</p>
        </Alert>
        <div className="flex gap-2">
          <Button variant="primary" onClick={() => window.location.reload()}>
            โหลดหน้าใหม่
          </Button>
          <Button onClick={() => this.setState({ error: null })}>ลองอีกครั้ง</Button>
        </div>
      </div>
    )
  }
}
